// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/dist/ScrollToPlugin'
import 'promise-polyfill/src/polyfill';

import 'doT';
import './_modernizr';
import 'pickadate';
import 'pickadate-date';
import 'jplayer';
import 'moment';
import select2 from 'select2';

import PrimaryNav from '../../../_modules/primary-nav/primary-nav';

import './_click-out';
import './_home';
import './_dashboard';
import './_new-patient';
import './_hcp-details--hdm';
import './_hcp-details--cs';
import './_forgot-pwd';
import './_manage-patients';
import './_select-institute';
import './_register';
import './_payment';
import './_view-institution';
import './_view-order';
import './_view-order-review';
import './_view-regimen';
import './_form-modal';
import './_dashboard-cust-service';
import './_dashboard-staffshop';
import './_dashboard-abbottadmin-order';
import './_hcp-cust-service';
import './_new-client-cust-service';
import './_transfer-client';
import './_reports';
import './_view-tender';
import './_new-product';

import { debounce, adjustFooterOnWindowResize } from './_helper';

// Import Modules
import BackToLink from '../../../_modules/back-to-link/back-to-link';
import ButtonToggle from '../../../_modules/button-toggle/button-toggle';
import ButtonCounter from '../../../_modules/button-counter/button-counter';
import ButtonFilter from '../../../_modules/button-filter/button-filter';
import ButtonForm from '../../../_modules/button-form/button-form';
import ButtonSearch from '../../../_modules/button-search/button-search';
import CrudTable from '../../../_modules/crud-table/crud-table';
import CustomSelectValue from '../../../_modules/custom-select-value/custom-select-value';
import EditableInput from '../../../_modules/editable-input/editable-input';
import GlobalSearch from '../../../_modules/global-search/global-search';
import AdminNewAccount from '../../../_modules/admin-new-account/admin-new-account';
import UpdatePassword from '../../../_modules/update-password/update-password';
import UpdateDetails from '../../../_modules/update-details/update-details';
import UpdateClientDetails from '../../../_modules/update-client-details/update-client-details';
import Dropdown from '../../../_modules/dropdown/dropdown';
import DropdownNotification from '../../../_modules/dropdown-notification/dropdown-notification';
import FilterDropdown from '../../../_modules/filter-dropdown/filter-dropdown';
import FormInput from '../../../_modules/form-input/form-input';
import FormDropdown from '../../../_modules/form-dropdown/form-dropdown';
import MultiStepNav from '../../../_modules/multi-steps-nav/multi-steps-nav';
import PlaceAutocomplete from '../../../_modules/place-autocomplete/place-autocomplete';
import PoNumber from '../../../_modules/po-number/po-number';
import ProductsList from '../../../_modules/products-list/products-list';
import Radio from '../../../_modules/radio-button/radio-button';
import Switch from '../../../_modules/switch/switch';
import Tabs from '../../../_modules/tabs/tabs';
import TableSort from '../../../_modules/table-sort/table-sort';
import Modal from '../../../_modules/modal/modal';
import Login from '../../../_modules/login/login';
import Register from '../../../_modules/register/register';
import ServerError from '../../../_modules/server-error/server-error';
import Video from '../../../_modules/video/video';
import VideoLink from '../../../_modules/video-link/video-link';
import CarerDetail from '../../../_modules/carer-detail/carer-detail';
import CarerDetailUpdate from '../../../_modules/carer-details-update/carer-details-update';
import HensContent from '../../../_modules/hens-content/hens-content';

import SummaryDashboard from '../../../_modules/summary-dashboard/summary-dashboard';

import TableWorkplace from '../../../_modules/table-workplace/table-workplace';
import StaffShopNewAccount from '../../../_modules/staffshop-users/staffshop-users';
import TenderPriceManagement from '../../../_modules/tender-price/tender-price';


// Variable declaration
var $window = $(window),
    $body = $('body'),
    $header = $('.header'),
    isMobileDevice = Modernizr.mq('(max-width: 1024px)'),
    lastScrollTop = 0,
    today = new Date();

$(() => {
    new PrimaryNav();   // Activate Primary Nav modules logic

    // Activate modules
    new BackToLink();
    new ButtonToggle();
    new ButtonCounter();
    new ButtonForm();
    new ButtonSearch();
    new AdminNewAccount();
    new CrudTable();
    new CustomSelectValue();
    new EditableInput();
    new UpdatePassword();
    new UpdateDetails();
    new UpdateClientDetails();
    new ButtonFilter();
    new GlobalSearch();
    new Dropdown();
    new DropdownNotification();
    new FilterDropdown();
    new FormInput();
    new FormDropdown();
    new MultiStepNav();
    new PoNumber();
    new PlaceAutocomplete();
    new ProductsList();
    new Radio();
    new Switch();
	new Tabs();
    new TableSort();
    new Modal();
    new Login();
    new Register();
    new ServerError();
    new Video();
    new VideoLink();
    new CarerDetail();
    new CarerDetailUpdate();
    new StaffShopNewAccount();
    new HensContent();
    new TenderPriceManagement();

    //todo review it later why it is binding twice.
    // new SummaryDashboard();

    new TableWorkplace();

    ////////////////////////////
    // Set framerate to 60fps //
    ////////////////////////////
    gsap.ticker.fps(60);
    gsap.registerPlugin(ScrollToPlugin);

    //////////////////////
    // Init PickaDate //
    //////////////////////

    let today = new Date(),
        dd = today.getDate(),
        mm = today.getDay(),
        yyyy = today.getYear();
    
    select2();

    $('.datepicker').pickadate({
        format: 'dd-mm-yyyy'
    });


    $('.regimen-datepicker').pickadate({
        format: 'dd-mm-yyyy'
    });

    $('.datepicker__min-today').pickadate({
        format: 'dd-mm-yyyy',
        min: today
    });


    $(document).on('click', '.picker__input', function(){
        $(this)
            .trigger('focus');
    });

    //pushing section wrap down when main nav adds a second line.
    let mainNav = $('.main-nav'),
        sectionWrap = $('section.section > .container > .wrap');

    $window.on('resize', function () {

        (mainNav.outerHeight() > 70)
            ? sectionWrap.addClass('header__extra-top-margin')
            // ? console.log('kicking as well')
            : sectionWrap.removeClass('header__extra-top-margin');

    });

    ////////////
    // Logout //
    ////////////
    // Deactivate Patient
    $('.js-logout').on('click', function (e){
        e.preventDefault();

        let isMobileDevice = Modernizr.mq('(max-width: 767px)');

        $.fancybox.open('#logout', {
            autoSize: false,
            closeBtn: false,
            fitToView: false,
            height: isMobileDevice == true ? 300 : 200,
            width: isMobileDevice == true ? 250 : 500,
            padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
            type: 'inline',
            wrapCSS: 'modal',
            afterShow: function(){
                $('.js-agree-logout').on('click', function (e){
                    $.fancybox.close();

                    setTimeout(function () {
                        window.location = $('.js-logout').attr('href');
                    }, 100);
                });
            }
        });
    });

    /* "New Regimen" button:
    ** - go to dashboard page
    ** - display only regimen section by using session storage
    */
    $('.js-new-regimen').on('click', function (e){
        e.preventDefault();

        var url = $(this).attr('href');

        sessionStorage.setItem('isCreateRegimen', 'true');

        window.location.href = url;
    });

    /////////////////////////////
    // Placeholder Alternative //
    /////////////////////////////
    (function () {
        var $inputText = $('input[type="text"]');

        if ($('.no-placeholder').length) {
            $inputText
                .each(function () {
                    var $this = $(this);
                    $this.addClass('blur').attr('value', $this.attr('placeholder'));
                })
                .on('focus', function () {
                    var $this = $(this);

                    if ($this.val() == $this.attr('placeholder')) {
                        $this.val('').removeClass('blur');
                    }
                })
                .on('blur', function () {
                    var $this = $(this);
                    if ($this.val() == '') {
                        $this.val($this.attr('placeholder')).addClass('blur');
                    }
                });
        }
    })();

    $('.dataTables_filter input[type="search"]').attr("placeholder", "Type your search term");

    ////////////////////////////////////
    //Background-size: cover Fallback //
    ////////////////////////////////////
    (function () {
        if ($('.no-bgsizecover').length) {
            $('.backstretch').each(function () {
                var $this = $(this),
                    $dataOriginal = $this.data('original');

                $this.backstretch($dataOriginal);
            });
        }
    })();


    /////////////////////
    // Header Toggling //
    /////////////////////
    (function () {
        $window.on('resize scroll', debounce(toggleHeader, 250));

        function toggleHeader() {
            var st = $(this).scrollTop(),
                $headerHeight = $header.height(),
                isHomePage = $('.hero-image').length,
                $regimen = $('.product-details'),
                isCreateRegimen = $regimen.length;

            isMobileDevice = Modernizr.mq('(max-width: 1024px)');

            if (!isMobileDevice) {
                if (st > lastScrollTop) {
                    // scroll down
                    if (!isHomePage && st > $headerHeight) {
                        $header.addClass('hide').removeClass('compact');
                    }
                } else {
                    // scroll up
                    if (st <= $headerHeight) {
                        $header.removeClass('compact hide');
                    }
                    else {

                        if(isCreateRegimen && st > $regimen.offset().top && st < $('#DieticiansPatientNotes').offset().top ){
                            // Don't scroll
                        }else{
                            $header.addClass('compact');
                        }
                    }
                }
            }

            lastScrollTop = st;
        };
    })();


    /////////////////////
    // Header Style:adjust margin top //
    /////////////////////
    (function () {
        $window.on('resize', debounce(setMarginHeader, 250));

        function setMarginHeader(){
            let $header = $('header'),
                $main = $('#main'),
                headerHeight = $header.outerHeight();

            $main.css('margin-top', headerHeight);
        }

    })();


    /////////////////////////////////
    // Short content moving footer //
    /////////////////////////////////
    (function () {
        adjustFooterOnWindowResize();
    })();


    //////////////////////////////////////////////////
    // Killswitch to open all links in Page Listing //
    //////////////////////////////////////////////////
    $('.page-listing h2').on('click', function() {
        $('.page-listing li').each(function () {
            window.open($(this).find('a').attr('href'), '_blank');
            window.focus();
        });
    });

    $('.js-print-page').on('click', function (e){

        e.preventDefault();

        let $print = $('.section.print'),
            $body = $('body'),
            $header = $('.header'),
            $main = $('#main'),
            $footer = $('.footer'),
            $printDetails;

        $print.addClass('.ecco');
        $printDetails = $print.html();

        //hiding sections that don't need to be printed
        $header.hide();
        $main.hide();
        $footer.hide();

        $body.append($printDetails);

        // Chrome fix - A fix to what?
        setTimeout(function() {
            window.print();
            window.location.href = currentUrl;
        }, 250);
    });

    $('.js-print-url').on('click', function (e){
        e.preventDefault();

        var anchor = $(e.target);
        var printUrl = anchor.attr("data-print-url");

        var printWindow = window.open(printUrl);

        // Use attachEvent instead of addEventListener when the browser is IE
        printWindow[printWindow.addEventListener ? 'addEventListener' : 'attachEvent'](
            (printWindow.attachEvent ? 'on' : '') + 'load', function(){

                let $print = $('.section.print', printWindow.document),
                    $body = $('body', printWindow.document),
                    $header = $('.header', printWindow.document),
                    $main = $('#main', printWindow.document),
                    $footer = $('.footer', printWindow.document),
                    $printDetails;

                $print.addClass('.ecco');
                $printDetails = $print.html();

                // Hide the sections we don't want to print
                $header.hide();
                $main.hide();
                $footer.hide();

                $body.append($printDetails);

                printWindow.document.close();
                printWindow.focus();
                printWindow.print();
                setTimeout(function() {
                    printWindow.close();
                }, 250);
            }, false
        );
    });
});
